import { gql } from '@apollo/client';
import { ManufacturerInfo } from '../fragments';

export default gql`
  query manufacturer($id: ID) {
    manufacturer(id: $id) {
      ...ManufacturerInfo
    }
  }
  ${ManufacturerInfo}
`;
